'use client';

import { Fragment } from 'react';
import { SliceZone } from '@prismicio/react';
import { PrismicNextLink } from '@prismicio/next';

import { Box } from '@preventx/oxygen';

// Contexts
import { useSiteNavigationContext } from '@/context/SiteNavigationProvider';

// Components
import { NavigationDropdown } from './NavigationDropdown';
import { NavigationMultiColumnDropdown } from './NavigationMultiColumnDropdown';
import { SectionIdentifierNavigationItem } from './SectionIdentifierNavigationItem';

// Slices
import { components as navigationComponents } from '@/slices/navigation';

type StandardSiteNavigationProps = {
  navigationTitle: string;
};

export const StandardSiteNavigation = ({
  navigationTitle,
}: StandardSiteNavigationProps) => {
  const { navigation } = useSiteNavigationContext();

  if (navigation.length === 0) {
    return;
  }

  return (
    <Box component="div" className="nav-drawer">
      <Box
        addCluster
        component="nav"
        className="site-head__nav"
        aria-label={navigationTitle}
      >
        {navigation.map(
          ({ id, link, section, dropdown, multiColumnDropdown }) => (
            <Fragment key={`standard-site-navigation-${id}`}>
              {link && (
                <PrismicNextLink field={link} className="site-head__link" />
              )}

              {section && (
                <SectionIdentifierNavigationItem
                  id={section.id}
                  title={section.title}
                  label={section.label}
                />
              )}

              {dropdown && <NavigationDropdown dropdown={dropdown} />}

              {multiColumnDropdown && (
                <NavigationMultiColumnDropdown
                  label={multiColumnDropdown.label}
                >
                  {multiColumnDropdown.columnOne && (
                    <Box component="div">
                      <SliceZone
                        slices={multiColumnDropdown.columnOne}
                        components={navigationComponents}
                      />
                    </Box>
                  )}

                  {multiColumnDropdown.columnTwo && (
                    <Box component="div">
                      <SliceZone
                        components={navigationComponents}
                        slices={multiColumnDropdown.columnTwo}
                      />
                    </Box>
                  )}

                  {multiColumnDropdown.columnThree && (
                    <Box component="div">
                      <SliceZone
                        components={navigationComponents}
                        slices={multiColumnDropdown.columnThree}
                      />
                    </Box>
                  )}
                </NavigationMultiColumnDropdown>
              )}
            </Fragment>
          ),
        )}
      </Box>
    </Box>
  );
};
